import {
  Block,
  Settings,
  SettingSectionTitle,
  SettingsFlexbox
} from '@/components/DybrComponents/StyledServicePagesElements';
import { selectActiveProfileSettingsAugmented } from '@/store/user/selectors/selectActiveProfileSettingsAugmented';
import { updateProfileSetting } from '@/store/user/thunks/updateProfileSetting';
import { useState } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import RadioGroup from '../../../../components/FormElements/RadioGroup';
import {
  useActiveProfile,
  useTokenState
} from '../../../../store/localStorage/useTokenState';
import { MailingOptions } from '../../../../utils/privacy/MailingOptions';

const options = [
  {
    label: 'как заголовки',
    value: MailingOptions.title
  },
  {
    label: 'полностью',
    value: MailingOptions.full
  }
].map((option, index) => ({ ...option, radioValue: option.value }));

function MailingSettings() {
  const dispatch = useDispatch();
  const [token] = useTokenState();
  const { activeProfileId } = useActiveProfile();

  const settings = useSelector(state =>
    selectActiveProfileSettingsAugmented(state, { activeProfileId })
  );

  const [checkedOption, setCheckedOption] = useState(
    settings?.notifyRestrictions?.forbidEmail
      ? MailingOptions.title
      : MailingOptions.full
  );

  const checkOption = (newMailingOption, id) => {
    dispatch(
      updateProfileSetting(
        'notifyRestrictions.forbidEmail',
        newMailingOption === MailingOptions.title,
        token
      )
    );
    setCheckedOption(id);
  };

  return (
    <Block>
      <SettingsFlexbox>
        <SettingSectionTitle>
          <h4>Рассылка ваших записей</h4>
          <p>
            Пользователи могут получать ваши новые посты по почте, но вы можете
            решить, как именно это будет происходить
          </p>
        </SettingSectionTitle>
        <Settings>
          <RadioGroup
            title="ваши записи рассылаются"
            name="mailingOptions"
            checked={checkedOption}
            onCheck={checkOption}
            items={options}
          />
        </Settings>
      </SettingsFlexbox>
    </Block>
  );
}

export default MailingSettings;
